module.exports = __webpack_public_path__ + "static/img/NA.3b1bb1e1.png";